import { TERMS_URL, POLICY_URL } from './constants';

const getTermsURL = (identifier) => {
  if (identifier === 'terms') return TERMS_URL;
  return POLICY_URL;
};

export default getTermsURL;
